import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'


import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import authModule from '@/store/auth.js'
import stylesModule from '@/store/styles.js'
import errorsModule from '@/store/errors.js'
import practicasModule from '@/store/practicas.js'
import favoritosModule from '@/store/favoritos.js'
import dominiosModule from '@/store/dominios.js'
import miperfilModule from '@/store/miperfil.js'
import encuestasModule from '@/store/encuestas.js'
import popupinfoModule from '@/store/popup-info.js'

import appinfo from '../../package.json';

import messages from '@/translations';

import servers from '@/servers'

let domain = location.host;

if(!!!servers[domain]){
  domain = 'demo-front.dotia.es';
}

export const store = new Vuex.Store({
  state :{
    language: localStorage.getItem('language') || 'es',
    server : servers[domain],
    showMenu : (window.innerWidth > 1024),
    packageVersion: appinfo.version || '0'
  },
  actions :{
    changeLanguage : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
        }
        resolve(nextLang);
      });
    },
    setMenu : ({commit},status) =>{
      commit('setStatusMenu',status);
    },
    toggleMenu : ({commit}) =>{
      commit('toggleStatusMenu');
    },

  },
  getters : {
    getLanguage : state => state.language,
    getServer : state => state.server,
    getShowMenu : state => state.showMenu,
    getTexts : state => {
      return messages[state.language];
    },
    getVersion : state => state.packageVersion
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    },
    setStatusMenu(state,status){
      state.showMenu = status;
    },
    toggleStatusMenu(state){
      state.showMenu = !state.showMenu;
    }
  },
  modules :{
    authModule,
    stylesModule,
    errorsModule,
    practicasModule,
    favoritosModule,
    dominiosModule,
    miperfilModule,
    encuestasModule,
    popupinfoModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js